import { atom } from 'jotai'
import type { SelectSkillEntity } from 'sierra-client/features/skills/components/select-skills/types'

export const SelectedSkillsAtom = atom<{ status: 'idle' } | { status: 'ready'; skills: SelectSkillEntity[] }>(
  { status: 'idle' }
)
